/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Factoid
 */
export interface Factoid {
    /**
     * 
     * @type {string}
     * @memberof Factoid
     */
    readonly description?: string;
    /**
     * 
     * @type {string}
     * @memberof Factoid
     */
    readonly image?: string;
    /**
     * 
     * @type {number}
     * @memberof Factoid
     */
    readonly sort?: number;
}

export function FactoidFromJSON(json: any): Factoid {
    return FactoidFromJSONTyped(json, false);
}

export function FactoidFromJSONTyped(json: any, ignoreDiscriminator: boolean): Factoid {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'image': !exists(json, 'image') ? undefined : json['image'],
        'sort': !exists(json, 'sort') ? undefined : json['sort'],
    };
}

export function FactoidToJSON(value?: Factoid | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


